import { Component, Input, inject } from '@angular/core';
import { Location } from '@angular/common';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { ClipboardService } from 'ngx-clipboard';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-multi-table-card',
  templateUrl: './multi-table-card.component.html',
  styleUrls: ['./multi-table-card.component.scss'],
  standalone: false,
})
export class MultiTableCardComponent {
  private location = inject(Location);
  private rbs = inject(RightBridgeApiService);
  dialog = inject(MatDialog);
  private clippy = inject(ClipboardService);
  private snacky = inject(MatSnackBar);

  @Input() title;
  @Input() infoKey;
  @Input() tradeDetail;
  @Input() sourceDataButton;
  loading = false;

  emptyCellCheck(infoPoint) {
    if (infoPoint.varName === 'TaxBracketSource') {
      if (this.tradeDetail.Details[infoPoint.varSet][infoPoint.varName]) {
        return false;
      } else if (this.tradeDetail.Details[infoPoint.varSet]['TaxBracket']) {
        return false;
      }
      return true;
    }

    if (
      infoPoint.varSet &&
      this.tradeDetail.Details[infoPoint.varSet] &&
      this.tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
    ) {
      return false;
    }

    if (
      infoPoint.varSet &&
      this.tradeDetail.Details[infoPoint.varSet] &&
      !this.tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
    ) {
      return true;
    }

    if (this.tradeDetail[infoPoint.varName]) {
      return false;
    }

    return true;
  }

  viewSourceData() {
    window.open(
      `${this.location.prepareExternalUrl(
        `/trade-source-data/${this.tradeDetail.TradeID}`
      )}`,
      '_blank'
    );
  }

  decryptValue(value: string, title: string) {
    this.loading = true;
    this.rbs.decryptValue(value).subscribe({
      next: resp => {
        this.loading = false;
        if (resp['resultString']) {
          let dialogRef = this.dialog.open(WarnDialogComponent, {
            panelClass: 'warn-dialog',
            data: {
              headline: title,
              content: `Value: ${resp['resultString']}`,
              confirm: 'Copy to Clipboard',
              cancel: 'Close',
              hideCancel: false,
            },
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === 'continue') {
              this.clippy.copy(resp['resultString']);
              this.snacky.open(`Copied to clipboard!`, 'Close', {
                duration: 4000,
              });
            }
            dialogRef = null;
          });
        }
      },
      error: err => {
        this.loading = false;
        console.error('ERROR: ', err);
        this.snacky.open(
          `Oops! Something went wrong. Please try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
      },
    });
  }
}
